// import React from 'react'
// import { useNavigate } from 'react-router-dom'
// import PrimaryButton from '../../../components/common/PrimaryButton'
// import { ProductionHouseConstants } from './ProductionHouseConstants'
// import './ProductionHouse.scss'

// const ProductionHouse: React.FC = () => {
//   const navigate = useNavigate()
//   const { productionHouse } = ProductionHouseConstants

//   const handleButtonClick = (route: string) => {
//     navigate(route)
//   }

//   return (
//     <section className="production-house-container">
//       <div className="production-house-card">
//         <div className="p-h-left-section">
//           <h2 className="production-house-heading">{productionHouse.title}</h2>

//           <p className="production-house-copy">
//             <span className="production-house-copy-bold">
//               {productionHouse.heading} <span className="heading-suffix"></span>
//             </span>{' '}
//             — {productionHouse.headingSuffix} <br />
//             We don’t just stream matches. We produce cricket the way fans <br />
//             expect to see it.
//             <br />
//             Our 4K production cameras capture every ball in crystal-clear <br />
//             quality, streamed live and directly connected to the CricCenter{' '}
//             <br />
//             app. That means smooth playback, sharp visuals, and broadcast-{' '}
//             <br />
//             style graphics that feel like international matches, not local{' '}
//             <br />
//             recordings. With a professional production crew, multi-angle <br />
//             camera setup, and live commentary, every match gets the <br />
//             attention it deserves — from club games to top-level tournaments.{' '}
//             <br />
//             No shaky feeds. No basic overlays. Just clean, premium coverage.{' '}
//             <br />
//             And the best part? <br />
//             <span className="production-house-copy-bold">
//               You don’t just get a stream — you get your own branded app, <br />
//               powered by CricCenter.
//             </span>{' '}
//             One complete package: production, <br /> streaming, graphics,
//             commentary, and technology — all under your control.
//           </p>

//           <PrimaryButton
//             text={productionHouse.button.text}
//             onClick={() => handleButtonClick(productionHouse.button.route)}
//           />
//         </div>

//         <div className="p-h-banner-mob">
//           <div className="banner-content">
//             {[...Array(5)].map((_, i) => (
//               <React.Fragment key={i}>
//                 <span className="banner-text">
//                   {productionHouse.banner.text}
//                 </span>
//                 <span className="banner-icon">*</span>
//               </React.Fragment>
//             ))}
//           </div>
//         </div>

//         <div className="right">
//           <h2 className="production-house-heading-mob">
//             {productionHouse.title}
//           </h2>
//           <img
//             src={productionHouse.images.stadium}
//             alt="Cricket stadium at night"
//             className="production-house-stadium-image"
//           />

//           <div className="p-h-right-section">
//             <div className="production-house-banner">
//               <div className="banner-content">
//                 {[...Array(5)].map((_, i) => (
//                   <React.Fragment key={i}>
//                     <span className="banner-text">
//                       {productionHouse.banner.text}
//                     </span>
//                     <span className="banner-icon">*</span>
//                   </React.Fragment>
//                 ))}
//               </div>
//             </div>
//           </div>

//           <div className="production-house-overlay production-house-overlay-top">
//             <p>{productionHouse.overlays.top}</p>
//           </div>

//           <div className="production-house-overlay production-house-overlay-bottom">
//             <p>{productionHouse.overlays.bottom}</p>
//           </div>
//         </div>
//       </div>
//     </section>
//   )
// }

// export default ProductionHouse

// // import React from "react";
// // import { useNavigate } from "react-router-dom";
// // import PrimaryButton from "../../../components/common/PrimaryButton";
// // import { ProductionHouseConstants } from "./ProductionHouseConstants";
// // import "./ProductionHouse.scss";

// // const ProductionHouse: React.FC = () => {
// //     const navigate = useNavigate();
// //     const { productionHouse } = ProductionHouseConstants;

// //     const handleButtonClick = (route: string) => {
// //         navigate(route);
// //     };

// //     return (
// //         <section className="production-house">
// //             <div className="production-house-container">
// //                 <div className="production-house-content">
// //                     <h2 className="production-house-mobile-title">{productionHouse.title}</h2>

// //                     <div className="production-house-text-panel">

// //                         <div className="production-house-copy">
// //                             <h2 className="production-house-title production-house-title-desktop">
// //                                 {productionHouse.title}
// //                             </h2>
// //                             <h3 className="production-house-heading">
// //                                 {productionHouse.heading}
// //                                 <span className="heading-suffix"> — {productionHouse.headingSuffix}</span>
// //                             </h3>

// //                             <p className="production-house-description">
// //                                 {productionHouse.description}
// //                             </p>

// //                             <p className="production-house-highlighted">
// //                                 <strong>{productionHouse.highlightedText}</strong>
// //                             </p>

// //                             <div className="production-house-summary-wrapper">
// //                                 <p className="production-house-summary">{productionHouse.summary}</p>
// //                             </div>

// //                             <PrimaryButton
// //                                 text={productionHouse.button.text}
// //                                 onClick={() => handleButtonClick(productionHouse.button.route)}
// //                             />
// //                         </div>
// //                     </div>

// //                     <div className="production-house-visual">
// //                         <div className="production-house-image-wrapper">
// //                             <img
// //                                 src={productionHouse.images.stadium}
// //                                 alt="Cricket stadium at night"
// //                                 className="production-house-stadium-image"
// //                             />

// //                             <div className="production-house-banner">
// //                                 <div className="banner-content">
// //                                     {[...Array(5)].map((_, i) => (
// //                                         <React.Fragment key={i}>
// //                                             <span className="banner-text">{productionHouse.banner.text}</span>
// //                                             <span className="banner-icon">*</span>
// //                                         </React.Fragment>
// //                                     ))}
// //                                 </div>
// //                             </div>

// //                             <div className="production-house-overlay production-house-overlay-top">
// //                                 <p>{productionHouse.overlays.top}</p>
// //                             </div>

// //                             <div className="production-house-overlay production-house-overlay-bottom">
// //                                 <p>{productionHouse.overlays.bottom}</p>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>
// //         </section>
// //     );
// // };

// // export default ProductionHouse;




import React from 'react'
// import { useNavigate } from 'react-router-dom'
// import PrimaryButton from '../../../components/common/PrimaryButton'
import ballIcon from '../../../assets/images/icons/ball_icon.svg'
import prodMobileImage from '../../../assets/images/prodimg.jpg'
import { ProductionHouseConstants } from './ProductionHouseConstants'
import './ProductionHouse.scss'

const ProductionHouse: React.FC = () => {
  // const navigate = useNavigate()
  const { productionHouse } = ProductionHouseConstants
  const bannerItemCount = 18

  // const handleButtonClick = (route: string) => {
  //   navigate(route)
  // }

  const renderBannerItems = (keyPrefix: string) =>
    [...Array(bannerItemCount)].map((_, i) => (
      <React.Fragment key={`${keyPrefix}-${i}`}>
        <span className="banner-text">{productionHouse.banner.text}</span>
        <img src={ballIcon} alt="" className="banner-icon" aria-hidden="true" />
      </React.Fragment>
    ))

  return (
    <section className="production-house-container">
      <div className="production-house-card">
        <div className="p-h-left-section">
          <h2 className="production-house-heading">{productionHouse.title}</h2>

          <div className="production-house-copy">
            <span className="production-house-copy-bold production-house-highlight-text">
              {productionHouse.heading}
            </span>{' '}
            <br />
            {productionHouse.headingSuffix} <br />
            {/* We don’t just stream matches. We produce cricket the way fans <br />
            expect to see it.
            <br />
            Our 4K production cameras capture every ball in crystal-clear <br />
            quality, streamed live and directly connected to the CricCenter{' '}
            <br />
            app. That means smooth playback, sharp visuals, and broadcast-{' '}
            <br />
            style graphics that feel like international matches, not local{' '}
            <br />
            recordings. With a professional production crew, multi-angle <br />
            camera setup, and live commentary, every match gets the <br />
            attention it deserves — from club games to top-level tournaments.{' '}
            <br />
            No shaky feeds. No basic overlays. Just clean, premium coverage.{' '}
            <br />
            And the best part? <br /> */}
            <ul
              className="production-house-copy-second-bold"
              style={{ marginTop: '20px', paddingLeft: '24px' }}
            >
              <li>4K Live Streaming</li>
              <li>Multi-Camera Production</li>
              <li>Pro Commentary</li>
              <li>Cinematic Aerial Drone Coverage.</li>
            </ul>{' '}
            <div className="" style={{ marginTop: '20px' }}>Because Every Match Deserves a Broadcast.
              <br />
              <span className="production-house-highlight-text">
                Broadcast Worldwide with <span className="production-house-copy-bold">CricCenter</span>.
              </span>
            </div>
            <br />

          </div>

          {/* <PrimaryButton
            text={productionHouse.button.text}
            onClick={() => handleButtonClick(productionHouse.button.route)}
          /> */}
        </div>

        <div className="p-h-banner-mob">
          <div className="banner-content">
            <div className="banner-marquee">
              <div className="banner-track">{renderBannerItems('mob-a')}</div>
              <div className="banner-track" aria-hidden="true">
                {renderBannerItems('mob-b')}
              </div>
            </div>
          </div>
        </div>

        <div className="right">
          <h2 className="production-house-heading-mob">
            {productionHouse.title}
          </h2>
          <picture>
            <source media="(max-width: 1024px)" srcSet={prodMobileImage} />
            <img
              src={productionHouse.images.stadium}
              alt="Cricket stadium at night"
              className="production-house-stadium-image"
            />
          </picture>

          <div className="p-h-right-section">
            <div className="production-house-banner">
              <div className="banner-content">
                <div className="banner-marquee">
                  <div className="banner-track">{renderBannerItems('desk-a')}</div>
                  <div className="banner-track" aria-hidden="true">
                    {renderBannerItems('desk-b')}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="production-house-overlay production-house-overlay-top">
            <p>{productionHouse.overlays.top}</p>
          </div>

          <div className="production-house-overlay production-house-overlay-bottom">
            <p>{productionHouse.overlays.bottom}</p>
          </div>
        </div>
      </div>
    </section >
  )
}

export default ProductionHouse
